import { RError404 } from "@/pages/Errors/views/Error404/RError404";
import { RouteConfig } from "vue-router";
import { RLogin } from "./views/Login/RLogin";
import { RPasswordReset } from "./views/PasswordReset/RPasswordReset";
import { RRegistration } from "./views/Registration/RRegistration";

export const RAuth: RouteConfig = {
  path: "/auth",
  component: () =>
    import(
      /* webpackChunkName: "auth" */
      "./PAuth.vue"
    ),
  children: [
    {
      path: "",
      redirect: RLogin.path,
    },
    RRegistration,
    RLogin,
    RPasswordReset,
    RError404,
  ],
};
